<template>
    <v-dialog max-width="500">
        <template v-slot:default="{ isActive }">
            <v-card>
                <v-card-title class="text-primary">
                    Aviso
                </v-card-title>
                <v-card-text>
                    Contate o proprietário para realizar a troca da senha.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text="Ok"
                        color="primary"
                        @click="isActive.value = false"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>